// extracted by mini-css-extract-plugin
export default {"edit-table":"edit-table__NKj+5"};